import { ReactNode, useState } from 'react';

import { Typography, julo } from '@julo-ui/react';

import downIcon from 'assets/ic-chevron-down.svg';
import checkIcon from 'assets/ic-check-circle.svg';

import { reviewAccordion } from '../styles';

interface Props {
  title: string;
  children: ReactNode;
}

const ReviewAccordion = (props: Props) => {
  const { title, children } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggleVisibility = () => {
    setIsOpen(!isOpen);
  };

  return (
    <julo.div className={reviewAccordion(isOpen)}>
      <julo.div className='header' onClick={toggleVisibility}>
        <julo.div className='title'>
          <julo.img src={checkIcon} alt='check circle icon' />
          <Typography type='body' bold>
            {title}
          </Typography>
        </julo.div>
        <julo.img src={downIcon} alt='down icon' className='toggle-btn' />
      </julo.div>
      {isOpen && <div className='content'>{children}</div>}
    </julo.div>
  );
};

export default ReviewAccordion;
